const UsersPage = () => {
  return (
    <div>
      <h2>Users</h2>
      <p>This is the users page content.</p>
    </div>
  );
};

export default UsersPage;
